import { useState } from 'react';

function useToggle(initialState) {
  if (initialState === void 0) {
    initialState = false;
  }

  var _useState = useState(initialState),
      isActive = _useState[0],
      setActive = _useState[1];

  var activate = function activate() {
    return setActive(true);
  };

  var deactivate = function deactivate() {
    return setActive(false);
  };

  var toggle = function toggle() {
    return setActive(function (visible) {
      return !visible;
    });
  };

  return {
    isActive: isActive,
    activate: activate,
    deactivate: deactivate,
    toggle: toggle
  };
}

export { useToggle };